import { createCachedSelector } from 're-reselect';
import { createSelector } from 'reselect';
import { AssetDelta, ChangesState } from 'store/changes/types';
import { State } from 'store/types';

type ChangesStateTree = Omit<Partial<State>, 'changes'> &
  Pick<State, 'changes'>;

const selectChanges = (state: ChangesStateTree): ChangesState => state.changes;

export const selectChangedAssets = createSelector(
  selectChanges,
  (changes: ChangesState): Record<string, AssetDelta> => changes.assets,
);

export const selectChangedAsset = createCachedSelector(
  selectChangedAssets,
  (_: ChangesStateTree, id: string): string => id,
  (assets: Record<string, AssetDelta>, id: string): AssetDelta | undefined =>
    assets[id],
)((_: ChangesStateTree, id: string) => id);

export const selectAssetHasChanges = createCachedSelector(
  selectChangedAssets,
  (_: ChangesStateTree, id: string): string => id,
  (assets: Record<string, AssetDelta>, id: string): boolean => !!assets[id],
)((_: ChangesStateTree, id: string) => id);

export const selectHasLocalChanges = (state: ChangesStateTree): boolean =>
  !!Object.keys(state.changes.assets).length;
